
'use strict';
angular.module('newFileModule', []).controller('newFileModuleCtrl', [
    '$scope',
    '$modalInstance',
    'params',
    function ($scope, $modalInstance, params) {
        initStatus();

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.data = {
                title: '新建文件夹',
                desc: '文件夹名称',
                fileDesc: params.fileDesc || '',
            };
        }

        /**
         * [isConfirm description] 确定
         * @return {Boolean} [description]
         */
        $scope.isConfirm = function () {
            $modalInstance.close($scope.data.fileDesc);
        };

        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function () {
            $modalInstance.dismiss();
        };
    },
]);
